(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer =
        new IntersectionObserver(
          (entries, observer) => {
            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();
          }
        );

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(() => {
              this.preventReveal = false;
            }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );
        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) =>
          disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      this.searchModal.close(false);
    }
  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    function initPDP(root) {
    const descriptionPanel = root.querySelector('[class*="ai-pdp-accordion-panel-"].rte');
    if (descriptionPanel) {
      descriptionPanel.querySelectorAll('p, div').forEach(function(node) {
        if (node.querySelector('img, svg, iframe, video')) return;
        const hasText = node.textContent.replace(/\u00a0/g, ' ').trim().length > 0;
        const onlyBreaksOrBlank = node.innerHTML.replace(/(<br\s*\/?>|&nbsp;|\u00a0|\s)/gi, '') === '';
        if (!hasText && onlyBreaksOrBlank) {
          node.remove();
        }
      });
    }

    const galleryImgs = root.querySelectorAll('[class*="ai-pdp-main-img-"]');
    const thumbs = root.querySelectorAll('[class*="ai-pdp-thumb-"]');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const index = thumb.dataset.index;
        galleryImgs.forEach(function(img) {
          img.classList.toggle('is-active', img.dataset.index === index);
        });
        thumbs.forEach(function(t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    const zoomTrigger = root.querySelector('[class*="ai-pdp-zoom-trigger-"]');
    const zoomModal = root.querySelector('[class*="ai-pdp-zoom-modal-"]:not([class*="img"]):not([class*="close"])');
    const zoomModalImg = root.querySelector('[class*="ai-pdp-zoom-modal-img-"]');
    const zoomClose = root.querySelector('[class*="ai-pdp-zoom-close-"]');

    function openZoom() {
      if (!zoomModal || !zoomModalImg) return;
      const activeImg = root.querySelector('[class*="ai-pdp-main-img-"].is-active');
      if (activeImg) {
        zoomModalImg.src = activeImg.dataset.zoomSrc || activeImg.src;
        zoomModalImg.alt = activeImg.alt || '';
      }
      zoomModal.hidden = false;
    }

    function closeZoom() {
      if (zoomModal) zoomModal.hidden = true;
    }

    if (zoomTrigger) {
      zoomTrigger.addEventListener('click', openZoom);
    }
    if (zoomClose) {
      zoomClose.addEventListener('click', closeZoom);
    }
    if (zoomModal) {
      zoomModal.addEventListener('click', function(e) {
        if (e.target === zoomModal) closeZoom();
      });
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && zoomModal && !zoomModal.hidden) closeZoom();
    });

    const shareBtn = root.querySelector('[class*="ai-pdp-share-btn-"]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        const shareUrl = shareBtn.dataset.shareUrl;
        const shareTitle = shareBtn.dataset.shareTitle;
        if (navigator.share) {
          navigator.share({ title: shareTitle, url: shareUrl }).catch(function() {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(shareUrl).then(function() {
            const label = shareBtn.querySelector('[class*="ai-pdp-share-label-"]');
            const originalText = label ? label.textContent : '';
            shareBtn.classList.add('is-copied');
            if (label) label.textContent = 'Link Copied';
            setTimeout(function() {
              shareBtn.classList.remove('is-copied');
              if (label) label.textContent = originalText;
            }, 2000);
          }).catch(function() {});
        }
      });
    }

    root.querySelectorAll('[class*="ai-pdp-accordion-trigger-"]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const panel = trigger.closest('[class*="ai-pdp-accordion-"]:not([class*="trigger"]):not([class*="panel"]):not([class*="icon"])');
        if (panel) panel.classList.toggle('is-open');
      });
    });

    const qtyInput = root.querySelector('[class*="ai-pdp-qty-input-"]');
    const qtyMinus = root.querySelector('[class*="ai-pdp-qty-minus-"]');
    const qtyPlus = root.querySelector('[class*="ai-pdp-qty-plus-"]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        const val = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        qtyInput.value = val;
      });
      qtyPlus.addEventListener('click', function() {
        const val = parseInt(qtyInput.value || '1', 10) + 1;
        qtyInput.value = val;
      });
    }

    const form = root.querySelector('.ai-pdp-form');
    const variantIdInput = root.querySelector('[class*="ai-pdp-variant-id-"]');
    const atcBtn = root.querySelector('[class*="ai-pdp-atc-"]');

    const productJsonScript = root.querySelector('[data-ai-pdp-json]');
    const productData = productJsonScript ? JSON.parse(productJsonScript.textContent) : null;

    function findMatchingVariant(selections) {
      if (!productData) return null;
      return productData.variants.find(function(variant) {
        return variant.options.every(function(optionValue, index) {
          return selections[index] === undefined || selections[index] === optionValue;
        });
      });
    }

    const selections = [];
    root.querySelectorAll('[class*="ai-pdp-option-"]:not([class*="label"])').forEach(function(optionWrap) {
      const idx = parseInt(optionWrap.dataset.optionIndex, 10);
      const selectedBtn = optionWrap.querySelector('.is-selected');
      if (selectedBtn) selections[idx] = selectedBtn.dataset.value;
    });

    root.querySelectorAll('[class*="ai-pdp-size-btn-"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const optionWrap = btn.closest('[class*="ai-pdp-option-"]:not([class*="label"])');
        if (!optionWrap) return;
        const idx = parseInt(optionWrap.dataset.optionIndex, 10);
        optionWrap.querySelectorAll('[class*="ai-pdp-size-btn-"]').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selections[idx] = btn.dataset.value;

        const selectedValueLabel = optionWrap.querySelector('[class*="ai-pdp-selected-value-"]');
        if (selectedValueLabel) selectedValueLabel.textContent = btn.dataset.value;

        const match = findMatchingVariant(selections);
        if (match && variantIdInput) {
          variantIdInput.value = match.id;
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (atcBtn) atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantIdInput.value,
            quantity: qtyInput ? qtyInput.value : 1
          })
        })
          .then(function(res) { return res.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            /*
              Rebuy-presence check -- see @change above. window.Rebuy and the
              smart-cart--enabled body class are both real, confirmed-live signals that Rebuy's
              own Smart Cart script is active and about to render its own drawer UI on its own
              timeline. Previously this code unconditionally looked for a cart-drawer/
              cart-notification element and, failing to find one, immediately hard-redirected to
              /cart -- that redirect was firing before Rebuy's own (slightly slower) drawer-open
              logic ever got a chance to run, which is what a real screen recording confirmed:
              straight to the full cart page, no drawer motion, even with Rebuy's app embed on.
              When Rebuy is active, this code now stops here on purpose and lets Rebuy's own
              script take it from here -- no drawer lookup, no redirect, nothing that could race
              against or cut off Rebuy's UI.
            */
            const rebuyActive = !!window.Rebuy || document.body.classList.contains('smart-cart--enabled');
            if (rebuyActive) {
              if (atcBtn) atcBtn.disabled = false;
              return;
            }

            const drawer = document.querySelector('cart-drawer, cart-notification');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function() {
            window.location.href = '/cart';
          })
          .finally(function() {
            if (atcBtn) atcBtn.disabled = false;
          });
      });
    }

    }

    document.querySelectorAll('[data-ai-pdp-root]').forEach(initPDP);
  })();

  } catch(e) { console.error(e); }
})();
})();
